import React from "react"
import { Button } from "@pga/pga-component-library"
import { ModalTitle, StyledModal, SubText } from "../Prospect/PathBox/styles"

export const BECOME_ASSOCIATE_MODAL_TITLE = "Become an Associate"
export const BECOME_ASSOCIATE_MODAL_COPY =
  "Associate eligibility requires active employment at a PGA of America recognized facility."
export const BECOME_ASSOCIATE_MODAL_CONTINUE_LABEL = "Continue to Applications"

const BecomeAssociateModal = ({ isOpen, onClose, onApply }) => (
  <StyledModal isOpen={isOpen} toggle={onClose} centered size="lg">
    <div className="modal-body text-center">
      <ModalTitle>{BECOME_ASSOCIATE_MODAL_TITLE}</ModalTitle>
      <SubText>{BECOME_ASSOCIATE_MODAL_COPY}</SubText>
      <Button onClick={onClose} outline>
        Cancel
      </Button>{" "}
      <Button onClick={onApply}>{BECOME_ASSOCIATE_MODAL_CONTINUE_LABEL}</Button>
    </div>
  </StyledModal>
)

export default BecomeAssociateModal
